import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import classes from "./Sidebar.module.css";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector, useDispatch } from "react-redux";
import { ViewDetailsStoreAction } from "Store/ViewDetails";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const TraineeDetailsSidebar = (props) => {
  const [sideBarData, setSideBarData] = useState([]);

  const dispatch = useDispatch();
  const value = useSelector((state) => state.viewDetails);

  useEffect(() => {
    const details = props.data.map((item, i) => {
      if (i === value.index) {
        return {
          ...item,
          color: "#fff",
        };
      } else {
        return {
          ...item,
          color: "#f2f2f2",
        };
      }
    });

    setSideBarData(details);
  }, [props]);

  const handleClick = (i) => {
    dispatch(ViewDetailsStoreAction.updateIndex(i));
    let details = props.data.map((item, j) => {
      if (i === j) {
        return {
          ...item,
          color: "#fff",
        };
      } else {
        return {
          ...item,
        };
      }
    });

    setSideBarData(details);
  };

  return (
    <div className={"side-bar custom "}>
      <Typography
        component="p"
        sx={{
          bgcolor: "#fff",
          fontSize: 24,
          p: 1.25, // 10px = 1.25 * 8px (default spacing unit)
          color: "#ec6517",
          width: "100%",
          position: "fixed",
          fontWeight: "bold",
        }}
      >
        Core Info :
      </Typography>

      <Box sx={{ marginTop: 74 }}>
        {sideBarData.length > 0 &&
          sideBarData.map((val, i) => {
            const rowKey = `${val.ClassRequestId}-${val.ClassRosterId}-${val.ClassTraineeId}`;
            return (
              <Box
                key={rowKey}
                sx={{
                  backgroundColor: val.color,
                  margin: 8,
                  maxHeight: 200,
                }}
                onClick={() => handleClick(i)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClick(i);
                  }
                }}
              >
                <Grid key={rowKey} className="p-10px" container spacing={2}>
                  <Grid item xs={5}>
                    <p>Wave:</p>
                  </Grid>
                  <Grid item xs={7}>
                    <p>{val.Wave}</p>
                  </Grid>
                  <Grid item xs={5}>
                    <div
                      className={`${classes.coreInfoData} ${classes.margintop5}`}
                    >
                      <span> Class Request/</span>
                      <span> Roster/</span>
                      <span>Trainee Id :</span>
                    </div>
                  </Grid>
                  <Grid item xs={5}>
                    <p>
                      {val.ClassRequestId}/{val.ClassRosterId}/
                      {val.ClassTraineeId}
                    </p>
                  </Grid>
                  <Grid item xs={2}>
                    <ChevronRightIcon
                      className="cursor-pointer"
                      sx={{ fontSize: "45px" }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <p>Trainee Status :</p>
                  </Grid>
                  <Grid item xs={6}>
                    <p>{val.TraineeStatus}</p>
                  </Grid>
                  <Grid item xs={5}>
                    <p>Project :</p>
                  </Grid>
                  <Grid item xs={6}>
                    <Tooltip
                      title={val.ProjectName}
                      arrow
                      placement="right-start"
                    >
                      <div
                        className={`${classes.programContent}+ " " +  ' ' + ${classes.height15} ${classes.programOverflow}`}
                      >
                        {val.ProjectName}
                      </div>
                    </Tooltip>
                  </Grid>
                </Grid>
                <hr></hr>
              </Box>
            );
          })}
      </Box>
    </div>
  );
};

TraineeDetailsSidebar.propTypes = {
  data: PropTypes.any,
};

export default TraineeDetailsSidebar;
